import { HTMLInputTypeAttribute } from "react";

import "../Input.css";

type Props = Readonly<{
  "data-test-id"?: string;
  label: string;
  onChange: (val: boolean) => void;
  placeholder?: string;
  value?: string;
  checked?: boolean;
  type?: HTMLInputTypeAttribute;
  disabled?: boolean;
  labelSpan?: number;
  min?: number;
  max?: number;
  className?: string;
}>;

export default function CheckboxInput({
  label,
  value,
  checked,
  onChange,
  placeholder = "",
  "data-test-id": dataTestId,
  type = "checkbox",
  disabled = false,
  labelSpan = 2,
  min,
  max,
  className,
}: Props): JSX.Element {
  return (
    <div className="Input__wrapper">
      <label className="Input__label" style={{ textWrap: 'nowrap' }} htmlFor="checkbox-input">{label}</label>
      <input
        id="checkbox-input"
        type={type}
        className={`Input__input ${className}`}
        style={{ flex: `${labelSpan} 1`, position: 'relative', left: 'unset', height: '18px' }}
        checked={checked}
        onChange={(e) => {
          onChange(e.target.checked);
        }}
        data-test-id={dataTestId}
      />
    </div>
  );
}
